const SetLocStorage = (key, value) => localStorage.setItem(key, value)
const SetLocStorageString = (key, value) => localStorage.setItem(key, JSON.stringify(value))

const GetLocStorage = (key) => localStorage.getItem(key)
const GetLocStorageString = (key) => JSON.parse(localStorage.getItem(key) || 'null')

const ClearLocStorageItem = (key) => localStorage.removeItem(key)


export const LS = {
    setItem: SetLocStorage,
    setItemString: SetLocStorageString ,
    getItem: GetLocStorage,
    getItemString:GetLocStorageString ,
    removeItem: ClearLocStorageItem,
}
